<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nsSKRI/tc-custom/9781477321973.jpg?1720114161283" alt="This image is the cover for the book Renegades & Rogues"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Renegades & Rogues
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This biography of the creator of Conan the Barbarian is “</b><b>deep dive work,” in which “this ‘mysterious’ Texas scribe gets his most complete story arc told” (<i>Houston Press</i>).</b><br/>  <br/> Robert E Howard’s most famous creation, Conan the Barbarian, is an icon of popular culture. In hundreds of tales detailing the exploits of Conan, King Kull, and others, Howard helped to invent the sword and sorcery genre.<br/><br/> Todd B. Vick delves into newly available archives and probes Howard’s relationships, particularly with schoolteacher Novalyne Price, to bring a fresh, objective perspective to Howard's life. Like his many characters, Howard was an enigma and an outsider. He spent his formative years visiting the four corners of Texas, experiences that left a mark on his stories. He was intensely devoted to his mother, whom he nursed in her final days, and whose impending death contributed to his suicide in 1936 when he was just thirty years old.<br/><br/><i>Renegades &amp; Rogues</i> is an unequivocal journalistic account that situates Howard within the broader context of pulp literature. More than a realistic fantasist, he wrote westerns and horror stories as well, and engaged in avid correspondence with H. P. Lovecraft and other pulp writers of his day. Vick investigates Howard’s twelve-year writing career, analyzes the influences that underlay his celebrated characters, and assesses the afterlife of Conan, the figure in whom Howard’s fervent imagination achieved its most durable expression.<br/>  <br/> “A tour de force.” ―<i>Modern Age</i><br/>  <br/> “A compelling read.” —S. T. Joshi, author of <i>I Am Providence: The Life and Times of H. P. Lovecraft</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Todd B. Vick
      </h2>
      
      <p class="authorDescription body article"> Todd B. Vick, a researcher and independent scholar, has presented papers at multiple PCA/ACA conferences and runs &quot;On an Underwood No. 5,&quot; an award-winning blog devoted to Howard and pulp studies. He has contributed to Weird Fiction Review, The Dark Man Journal: The Journal of Robert E. Howard and Pulp Studies, and REH Changed My Life. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ebeeace